import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Card, CardActionArea, CardContent, Grid, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { BRAND } from '../../theme/brandTheme';
import { getBrandAccent, brandAccentTokens } from '../../utils/brandAccent';

/** Brand summary cards linking to each brand's dedicated page */
const BrandOverviewCards = ({ brands }) => {
  if (!brands?.length) return null;

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h5" component="h2" sx={{ fontWeight: 700, color: BRAND.purple, mb: 2 }}>
        Markalar
      </Typography>
      <Grid container spacing={2}>
        {brands.map((brand) => {
          const accent = getBrandAccent(brand, BRAND.purple);
          const tokens = brandAccentTokens(accent);

          return (
          <Grid item xs={12} sm={6} md={4} key={brand._id}>
            <Card
              sx={{
                height: '100%',
                border: `1px solid ${tokens.softBorder}`,
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                borderTop: `3px solid ${accent}`,
                transition: 'box-shadow 0.2s, transform 0.2s',
                '&:hover': { boxShadow: tokens.hoverShadow, transform: 'translateY(-2px)' },
              }}
            >
              <CardActionArea
                component={RouterLink}
                to={`/dashboard/brand/${brand._id}`}
                sx={{ height: '100%', p: 0 }}
              >
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                    {brand.logo && (
                      <Box
                        component="img"
                        src={brand.logo}
                        alt=""
                        sx={{ width: 40, height: 40, objectFit: 'contain' }}
                      />
                    )}
                    <Typography variant="h6" sx={{ fontWeight: 700, color: accent, flex: 1 }}>
                      {brand.name}
                    </Typography>
                    <ArrowForwardIcon sx={{ color: accent, fontSize: 20 }} />
                  </Box>

                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    <StatPill label="Canlı" value={brand.stats?.canli ?? 0} color="#0abc2a" />
                    <StatPill label="Taslak" value={brand.stats?.taslak ?? 0} color="#4472C4" />
                    <StatPill label="Durduruldu" value={brand.stats?.durduruldu ?? 0} color="#FFC000" />
                    <StatPill label="Toplam" value={brand.stats?.toplam ?? 0} color={accent} />
                  </Box>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

const StatPill = ({ label, value, color }) => (
  <Box
    sx={{
      px: 1.25,
      py: 0.5,
      borderRadius: 1,
      bgcolor: `${color}14`,
      border: `1px solid ${color}33`,
    }}
  >
    <Typography variant="caption" sx={{ color: BRAND.textMuted, mr: 0.5 }}>
      {label}:
    </Typography>
    <Typography component="span" variant="caption" sx={{ fontWeight: 700, color }}>
      {value}
    </Typography>
  </Box>
);

export default BrandOverviewCards;
